
const Status = ({ status }) => {
    return (
        <span className={getStatusBadge(status)}>
            {status || "TruCheck Review"}
        </span>
    )

}

export default Status

const getStatusBadge = (status) => {
    const styles = {
        "not init yet": "bg-slate-100 text-slate-600 border-slate-300",
        submitted: "bg-blue-100 text-blue-700 border-blue-300",
        created: "bg-yellow-100 text-yellow-700 border-yellow-300",
        approved: "bg-green-100 text-green-700 border-green-300",
        Clear: "bg-green-100 text-green-700 border-green-300",
        "Review Required": "bg-red-100 text-red-700 border-red-300",
        "Cannot Be Validated": "bg-orange-100 text-orange-700 border-orange-300",
        declined: "bg-red-100 text-red-700 border-red-300",
        "Completed": "bg-green-100 text-green-700 border-green-300",
        "TruCheck Review": "bg-yellow-100 text-yellow-700 border-yellow-300",
        "Link Sent": "bg-blue-100 text-blue-700 border-blue-300",
        "Eligible": "bg-green-100 text-green-700 border-green-300",
        "Not Eligible": "bg-red-100 text-red-700 border-red-300",
        "Ready for Adjudication": "bg-amber-100 text-amber-700 border-amber-300",
        "Canceled": "bg-gray-100 text-gray-600 border-gray-300",
    };

    return `inline-flex items-center px-3 py-1 rounded-lg border text-sm font-semibold ${styles[status] || "bg-gray-100 text-gray-700 border-gray-300"}`;
};
